import './DeathNotificationBody.scss';
import React, { useEffect } from 'react';
import ProgressBar from 'components/shared/ProgessBar/ProgressBar';
import SidePanel from 'components/shared/SidePanel/SidePanel';
import { getCurrentStep } from 'state/steps/StepSelectors';
import { connect } from 'react-redux';
import { progressBarSteps } from 'utils/LayoutUtils';
import { ReactComponent as Check } from 'assets/check.svg';
import { getCaseNumber } from 'state/submitNotification/SubmitNotificationSelectors';
import {
  listSteps,
  noSidePanelList,
} from 'utils/LayoutUtils';
import { getContentFragmentsForStep } from 'state/contentFragments/ContentFragmentSelectors';
import { analyticsPageLoad } from 'utils/AnalyticsUtils';

const DeathNotificationBody = ({ currentStep, contentFragments, caseNumber }) => {
  const { component, title, name, icon, analyticsPageName } = listSteps[currentStep];

  useEffect(() => {
    try {
      analyticsPageLoad(analyticsPageName)
    } catch {
      //eslint-disable-no-empty
    }

  }, [analyticsPageName])

  return (
    <div id={`${name}-body`}>
      <ProgressBar progressBarSteps={progressBarSteps}
                   icon={<Check />} />
      <div className="body-content">
        <main className="left-panel">
          <h1 data-testid="pageTitle"
              className="page-title">
            {icon && <span className="title-icon">{icon}</span>}{title}{caseNumber && `${caseNumber}.`}</h1>
          {component}
        </main>
        <aside className="right-panel">
          <SidePanel enable={!noSidePanelList.includes(currentStep)}
                     currentStep={currentStep}
                     contentFragments={contentFragments} />
        </aside>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  contentFragments: getContentFragmentsForStep(state),
  caseNumber: getCaseNumber(state)
});
export default connect(mapStateToProps)(DeathNotificationBody);